import { render, staticRenderFns } from "./Addgym.vue?vue&type=template&id=6d74ac43&"
import script from "./Addgym.vue?vue&type=script&lang=js&"
export * from "./Addgym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports